import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import noop from 'lodash/noop'
import CommonBtn from '../../components/global/CommonBtn'

function FormCard({ children, currentStep, prevFormStep }) {
    return (
        <div className='mt-3'>
            {currentStep < 3 && (
                <>
                    <span className='invisible'>Step {currentStep + 1} of 3</span>
                    {currentStep > 0 && (
                        <CommonBtn onClick={prevFormStep} className='btn btn-secondary float-end' isIconBtn icon={<i className="fa fa-chevron-circle-left"></i>} textRight="Back" />
                    )}

                </>
            )}
            <div className='mt-4'>{children}</div>
        </div>
    )
}

FormCard.propTypes = {
    dispatch: PropTypes.func,
    notify: PropTypes.func,
    children: PropTypes.func,
    currentStep: PropTypes.number,
    prevFormStep: PropTypes.number
}

FormCard.defaulProps = {
    dispatch: noop,
    notify: noop,
    children: noop,
    bookingFormPage: 1,
    currentStep: 0,
    prevFormStep: 0
}


function mapStateToProps({ globalReducers }) {
    return {
        selectedPassType: globalReducers?.selectedPassType,
        selectedEventId: globalReducers?.selectedEventId,
        bookingFormPage: globalReducers?.bookingFormPage
    }
}

export default connect(mapStateToProps)(FormCard)

